import { Capacitor } from '@capacitor/core';
import { Preferences } from '@capacitor/preferences';
import Page from 'components/page/page';
import WelcomeView from 'components/welcome-view/welcome-view';
import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import BlockerPlugin from 'utils/BlockerPlugin';

/* eslint-disable-next-line */
export interface IndexProps {}

export function Index(props: IndexProps) {
  const navigate = useNavigate();

  useEffect(() => {
    Preferences.get({ key: 'access_token' }).then(({ value }) => {
      if (value && value !== 'null') {
        navigate('/dashboard');
      }
    }).catch(error => {
       console.error('Error reading access_token preference:', error);
    });

    if (Capacitor.getPlatform() === 'ios') BlockerPlugin.requestTracking();
  }, [navigate]);

  return (
    <Page>
      <WelcomeView />
    </Page>
  );
}

export default Index;
